import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import Header from '@di-shared/features/common/Header';
import React, {ReactNode, useState} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';

function MileageGuidePage() {
  const {t} = useInferableTranslation();

  // TODO: KR에 맞는 수치값이 다국어 처리 없이 들어가있음 (EX. 10%, 300km 등) 다만 이건 한국 전용일 것 같아서... 필요시 대응할것
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1
          className="headline_xxsmall nav_center_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T40076')}
        </h1>
      </Header>
      <main className="content page_eco_mileage">
        <section className="section section_eco_guide">
          <div className="driving_accordion type_faq">
            <ul className="driving_accordion_list">
              <GuideItem
                title={t('T40077')}
                isInitOpen
              >
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T40078')}</li>
                </ul>
              </GuideItem>
              <GuideItem title={t('T40079')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T40080')}</li>
                </ul>
                <strong className="accordion_content_title">{t('T40081')}</strong>

                <ul className="section_number_list body_small_r">
                  <li className="section_number_item">{t('T40082')}</li>
                  <li className="section_number_item">{t('T40083')}</li>
                  <li className="section_number_item">{t('T40084')}</li>
                </ul>
              </GuideItem>
              <GuideItem title={t('T40085')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T40086')}</li>
                </ul>
                <strong className="accordion_content_title">{t('T40087')}</strong>

                <div className="mileage_standard">
                  <p
                    className="mileage_standard_title"
                    style={{whiteSpace: 'pre-wrap'}}
                  >
                    {t('T40088')}
                  </p>
                  <div className="mileage_standard_table">
                    <table>
                      <caption>
                        <span className="blind">{t('T40089')}</span>
                      </caption>
                      <colgroup>
                        <col />
                        <col style={{width: '80px'}} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">{t('T40090')}</th>
                          <th scope="col">{t('T40091')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">{t('T40092')}</th>
                          <td>20,000</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('T40093')}</th>
                          <td>30,000</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('T40094')}</th>
                          <td>50,000</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('T40095')}</th>
                          <td>70,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <strong className="accordion_content_title">{t('T40096')}</strong>

                <div className="mileage_standard">
                  <p className="mileage_standard_title">{t('T40097')}</p>
                  <div className="mileage_standard_table">
                    <table>
                      <caption>
                        <span className="blind">{t('T40098')}</span>
                      </caption>
                      <colgroup>
                        <col />
                        <col style={{width: '80px'}} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">{t('T40099')}</th>
                          <th scope="col">{t('T40091')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">{t('T40100')}</th>
                          <td>20,000</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('T40101')}</th>
                          <td>30,000</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('T40102')}</th>
                          <td>50,000</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('T40103')}</th>
                          <td>70,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </GuideItem>
              <GuideItem title={t('T40104')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T40105')}</li>
                  <li className="section_bullet_item">{t('T40106')}</li>
                </ul>
                <strong className="accordion_content_title">{t('T40107')}</strong>
                <p
                  className="accordion_content_desc"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  {t('T40108')}
                </p>
                <strong className="accordion_content_title">{t('T40109')}</strong>
                <p className="accordion_content_desc">{t('T40110')}</p>
                <strong className="accordion_content_title">{t('T40111')}</strong>
                <p className="accordion_content_desc">{t('T40112')}</p>
              </GuideItem>
              <GuideItem title={t('T40115')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T40120')}</li>
                  <li className="section_bullet_item">{t('T40121')}</li>
                </ul>
              </GuideItem>
              <GuideItem title={t('T40122')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">
                    <p>{t('T40123')}</p>
                    <ul className="section_number_list body_small_r">
                      <li className="section_number_item">{t('T40124')}</li>
                      <li className="section_number_item">{t('T40125')}</li>
                      <li className="section_number_item">{t('T40126')}</li>
                    </ul>
                  </li>
                </ul>
              </GuideItem>
              <GuideItem title={t('T40127')}>
                <ul className="section_bullet_list body_small_r">
                  <li
                    className="section_bullet_item"
                    style={{whiteSpace: 'pre-wrap'}}
                  >
                    {t('T40128')}
                  </li>
                </ul>
              </GuideItem>
            </ul>
          </div>
        </section>
      </main>
    </div>
  );
}

function GuideItem({title, isInitOpen = false, children}: {title: string; isInitOpen?: boolean; children: ReactNode}) {
  const [isOpen, setIsOpen] = useState(isInitOpen);

  return (
    <li className="driving_accordion_item">
      <button
        type="button"
        className="driving_accordion_btn"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((isOpen) => !isOpen)}
      >
        <span
          className="question_mark"
          aria-hidden={!isOpen}
        >
          Q
        </span>
        <span
          className="driving_accordion_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {title}
        </span>
        <span
          className="ic ic_arrow_down_16px"
          aria-hidden="true"
        ></span>
      </button>
      <div
        className="driving_accordion_content"
        style={{display: isOpen ? 'block' : 'none'}}
      >
        {children}
      </div>
    </li>
  );
}

export default MileageGuidePage;
